import React from 'react';

const Contact = () => (
  <div className="contact-container">
    <h2>Contact</h2>
    <p>
      Email me at <a href="mailto:erica.m.peterson@gmail.com">erica.m.peterson@gmail.com</a>, or reach out on{' '}
      <a href="https://www.linkedin.com/in/ericampeterson" target="_blank" rel="noopener noreferrer"> LinkedIn</a>.
    </p>
  </div>
);

export default Contact;
